import { Control } from 'react-hook-form'
import {
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
} from '@/common/ui/form'
import { ELIGIBILITY_TYPES } from '../constants'
import type { NotificationItemFormData } from '../types'

interface EligibilityFieldProps {
	control: Control<NotificationItemFormData>
}

export default function EligibilityField({ control }: EligibilityFieldProps) {
	return (
		<FormField
			control={control}
			name="eligibilityType"
			render={({ field }) => {
				const selectedEligibility = ELIGIBILITY_TYPES.find(
					(t) => t.value === field.value,
				)
				return (
					<FormItem>
						<FormLabel>เงื่อนไขการแสดง</FormLabel>
						<div className="rounded-lg border bg-muted/50 p-3">
							<div className="font-medium">{selectedEligibility?.label}</div>
							<div className="text-sm text-muted-foreground">
								{selectedEligibility?.description}
							</div>
						</div>
						<FormDescription>
							เงื่อนไขถูกกำหนดอัตโนมัติตามประเภทรายการ
						</FormDescription>
					</FormItem>
				)
			}}
		/>
	)
}
